import React from "react";

import { FacilityCode, Facility as FacilityLib } from "@secondcloset/fulfillment-utils";

import { Select } from "antd";
import { SelectProps } from "antd/lib/select";
import { sortBy } from "lodash-es";
import { Facility } from "api/common/facility";
import { useFacilityIndex } from "hooks/api/common/useFacilityIndex";

const { Option, OptGroup } = Select;

interface SelectFacilityProps extends SelectProps<FacilityCode> {
  filter?: (facilities: Facility[]) => Facility[];
}

export const SelectFacility: React.FC<SelectFacilityProps> = (props) => {
  const { data: facilities = [], isLoading } = useFacilityIndex();

  const facilityListByProvince = FacilityLib.getFacilityByProvince(
    props.filter ? props.filter(facilities) : facilities
  );

  return (
    <Select
      style={{ width: "100%" }}
      dropdownStyle={{ minWidth: 200 }}
      placeholder="Select Facility"
      loading={props.loading || isLoading}
      {...props}
    >
      {sortBy(Object.entries(facilityListByProvince), [([p]) => p]).map(([province, facilities]) => (
        <OptGroup label={province} key={province}>
          {sortBy(facilities, [(f) => f.name]).map((f) => (
            <Option key={f.code} label={f.name} value={f.code}>
              {f.name}
            </Option>
          ))}
        </OptGroup>
      ))}
    </Select>
  );
};
